
import { useEffect, useState } from "react";
import { Button, Grid, Stack } from "@mui/material"
import { BotonesAndCargando } from "../botones/BotonesAndCargando";
import { envVariables } from "../../../helpers";
import { useImagenStore, useModalesStore } from "../../../store";
import { VisuallyHiddenInput } from "../../../theme";
import { useParams } from "react-router-dom";
import { subirImagenXModelo } from "../../../services/utilities/uploads.service";
import nodoc from '../../../assets/imagenes/no-doc.jpg'; 
import { useQueryClient } from "@tanstack/react-query";

const url = envVariables.REACT_APP_API_URL;




export const ActualizarImagenes = ({ img, carpeta, campo, tipo, bloqueo=false, size=270, query='' }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { imagen, valorImagen } = useImagenStore();
    const { changeEstadoModalUno } = useModalesStore(); 
    const [cargando, setCargando] = useState(false);
    


    useEffect(() => {
        if(img){ valorImagen(img); }
    }, [img])



    const handleEditarPDF = async() => {
        const validar = ['string', 'undefined']
        if(validar.includes(typeof imagen)) return changeEstadoModalUno(false);

        setCargando(true)
        const data = { img:imagen, id, carpeta, campo, tipo };
        const resp = await subirImagenXModelo(data);
        setCargando(false)
        if( resp ){
            changeEstadoModalUno(false);
            valorImagen(null);
            queryClient.invalidateQueries({ queryKey: [query] }) 
        }
    }

    
            


    const handleFileChange = async( e ) => {
        valorImagen(e.target.files[0]);
    }



    return (

        <>
        <Grid item xs={12} sx={{display:'flex', justifyContent:'center', mb:1}}>
            <Stack>
                <Button sx={{width:size, height:size, borderRadius:'15px'}} component="label" 
                    onChange={ handleFileChange } disabled={bloqueo}
                >
                {(imagen)
                ?   <img src={(typeof imagen === 'string') 
                        ? `${url}/uploads/${carpeta}/${imagen}` 
                        : URL.createObjectURL(imagen)} 
                        style={{width:'100%', height:'100%'}}
                    />
                
                :   <img src={nodoc} alt="Imagen" style={{width:'100%'}} />
                }

                    <VisuallyHiddenInput type="file" />

                </Button>
            </Stack>
        </Grid>

        <Grid container sx={{mt:3, mb:2, display:'flex', justifyContent:'center' }}>
            <Grid item xs={12} sm={6}>
                <BotonesAndCargando
                    cargando={cargando}
                    titulo="Editar Imagen"
                    titulo2="Loading..."
                    icon1="save"
                    icon2="save"
                    handleSubmit={ handleEditarPDF }
                />
            </Grid>
        </Grid>
        </>

    )
}
